import React, { useState } from 'react';
import classes from './Contribution.module.css';
import Tilt from 'react-parallax-tilt';
import OpenSourceModal from './OpenSourceModal';

const Contribution = props => {
  const [show, setShow] = useState(false);

  const { title, imageSrc, color, width, height } = props.project;
  const showHandler = () => {
    setShow(true);
  };
  const hideHandler = () => {
    setShow(false);
  };

  return (
    <div>
      {show && <OpenSourceModal onClose={hideHandler} items={props.project} />}

      <div className={classes['project-items']} onClick={showHandler}>
        <div className={classes['project-container']}>
          <Tilt
            tiltMaxAngleX={40}
            tiltMaxAngleY={40}
            perspective={800}
            glareColor="#fff"
            glareEnable={true}
            glareMaxOpacity={0.7}
            glareBorderRadius="20px"
            glarePosition="all"
            gyroscope={true}
          >
            <div
              style={{ background: color }}
              className={classes['project-item']}
            >
              <Tilt perspective={1000}>
                {/*  trackOnWindow={true}*/}
                <img
                  className={classes.img}
                  style={{ width: width, height: height }}
                  src={imageSrc}
                  alt="img"
                />
              </Tilt>
              <h1 className={classes['project-name']}>{title}</h1>
            </div>
          </Tilt>
        </div>
      </div>
    </div>
  );
};

export default Contribution;
